import axios from "axios";
import { Constants } from "../utils/Constants";

export function get(termo = {}) {
    return axios.get(`${Constants.baseUrlV2}/get`);
}

export function getConfiguracaoAgendamento() {
    return axios.get(`${Constants.baseUrlV2}/get`);
}

export function updateConfiguracaoAgendamento(data) {
    return axios.put(`${Constants.baseUrlV2}/configuracao-agendamento`, data);
}

export function updateMeuPatio(formData) {
    return axios.post(`${Constants.baseUrlV2}/meu-patio`, formData);
}

export function updateLocalizacaoPatio(localizacao) {
    return axios.put(`${Constants.baseUrlV2}/localizacao`, localizacao);
}
